import React from 'react';
import { Search, Edit, Trash2 } from 'lucide-react';

const getStatusColor = status => {
  switch (status) {
    case 'CONFIRMADA':
      return 'bg-green-600';
    case 'PENDIENTE':
      return 'bg-yellow-600';
    case 'COMPLETADA':
      return 'bg-blue-600';
    case 'CANCELADA':
      return 'bg-red-600';
    default:
      return 'bg-gray-500';
  }
};

const AppointmentList = ({
  appointments,
  searchTerm,
  setSearchTerm,
  isLoading,
  handleEditAppointment,
  handleDeleteAppointment,
}) => {
  const iconProps = { className: 'h-4 w-4' };

  return (
    <div className="bg-secondary-main mt-5 rounded shadow">
      <div className="flex flex-col justify-between gap-4 p-4 md:flex-row">
        <div>
          <h2 className="text-lg font-semibold">Citas Agendadas ({appointments.length})</h2>
          <p className="text-sm text-gray-400">Próximas y pasadas citas del sistema</p>
        </div>
        <div className="relative w-full md:w-64">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            className="focus:ring-primary-main w-full rounded border border-gray-300 bg-black py-2 pl-10 pr-3 text-white focus:outline-none focus:ring-2"
            placeholder="Buscar por paciente, código o motivo..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="flex flex-col gap-4 overflow-y-auto p-4">
        {isLoading ? (
          <p className="py-8 text-center text-gray-400">Cargando citas...</p>
        ) : appointments.length > 0 ? (
          appointments.map(appt => (
            <div
              key={appt._id}
              className="bg-secondary-dark border-primary-active gap-4 rounded border p-4 shadow max-sm:flex-col max-sm:gap-3 sm:flex sm:items-center sm:justify-between"
            >
              <div className="min-w-[200px] flex-1">
                <h3 className="text-md font-semibold">
                  {appt.patient.firstName} {appt.patient.lastName}
                </h3>
                <p className="text-sm text-gray-300">Cód: **{appt.patientIdCode}**</p>
              </div>

              <div className="flex min-w-[300px] flex-1 flex-col items-start sm:flex-row sm:items-center sm:gap-4">
                <p className="rounded bg-gray-700 px-2 py-1 text-xs text-white">
                  {new Date(appt.date).toLocaleString('es-ES', {
                    dateStyle: 'short',
                    timeStyle: 'short',
                  })}
                </p>

                <span
                  className={`rounded px-2 py-1 text-xs font-bold uppercase text-white ${getStatusColor(appt.status)}`}
                >
                  {appt.status}
                </span>

                <span
                  className={`rounded bg-indigo-200 px-2 py-1 text-xs uppercase text-indigo-800`}
                >
                  {appt.type}
                </span>

                <p className="max-w-xs truncate text-sm text-gray-300">{appt.reason}</p>

                <div className="mt-2 flex gap-2 sm:mt-0">
                  <button
                    onClick={() => handleEditAppointment(appt)}
                    className="p-1 text-blue-300 hover:text-blue-600"
                    title="Editar cita"
                  >
                    <Edit {...iconProps} />
                  </button>
                  <button
                    onClick={() => handleDeleteAppointment(appt._id)}
                    className="p-1 text-red-300 hover:text-red-800"
                    title="Eliminar cita"
                  >
                    <Trash2 {...iconProps} />
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="py-8 text-center text-gray-400">No se encontraron citas agendadas.</p>
        )}
      </div>
    </div>
  );
};

export default AppointmentList;
